exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.has-gutter tr[data-v-5cee3858]{\r\n    background:#F5F5F5;\n}\n.but[data-v-5cee3858]{\r\n    height: 35px;\r\n    width: 120px;\r\n    border-radius: 6px;\r\n    margin: 10px 0;\r\n    color: #FFF;\r\n    background: #63a0f0;\r\n    border: none;\r\n    cursor: pointer;\n}\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5cee3858","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./src/components/physical/physical_org.vue
// module id = 49q9
// module chunks = 3